












































































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../../honcierge-api"
import Base64Uploader from "@/components/Base64Uploader.vue"
import DeleteButtonWithConfirm from "@/components/DeleteButtonWithConfirm.vue"
import { AxiosError } from "axios"

@Component({ components: { Base64Uploader, DeleteButtonWithConfirm } })
export default class Edit extends Vue {
  @Prop({ default: null })
  private id!: number | null

  private dialog = false

  private priority = 1
  private title = ""
  private link = ""
  private advertiser = ""
  private thumbnail: { content: string; filename: string } = {
    content: "",
    filename: "",
  }

  // rules for form
  private priorityRules = [
    (priority: number) => !!priority || "優先度は必須です",
  ]
  private titleRules = [(title: string) => !!title || "タイトルは必須です"]
  private linkRules = [(link: string) => !!link || "リンクURLは必須です"]
  private advertiserRules = [
    (advertiser: string) => !!advertiser || "広告主は必須です",
  ]

  public createOrUpdateSponsoredLink(): void {
    if (!this.validate()) {
      return
    }
    if (this.id !== null) {
      api
        .updateSponsoredLink({
          id: this.id,
          priority: this.priority,
          title: this.title,
          link: this.link,
          advertiser: this.advertiser,
          thumbnail: {
            filename: this.thumbnail.filename,
            content: this.thumbnail.content,
          },
        })
        .then(() => {
          this.emitSponsoredLink()
          this.$toasted.success("スポンサー広告を更新しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.$toasted.error(e.response.data.messages)
          }
        })
    } else {
      if (
        this.thumbnail &&
        (!this.thumbnail.filename || !this.thumbnail.content)
      ) {
        this.$toasted.error("サムネイルを指定してください")
        return
      }
      api
        .createSponsoredLink({
          priority: this.priority,
          title: this.title,
          link: this.link,
          advertiser: this.advertiser,
          thumbnail: {
            filename: this.thumbnail.filename,
            content: this.thumbnail.content,
          },
        })
        .then(() => {
          this.emitSponsoredLink()
          this.$toasted.success("スポンサー広告を新規作成しました")
        })
        .catch((e: AxiosError) => {
          if (e.response) {
            this.$toasted.error(e.response.data.messages)
          }
        })
    }
  }

  public deleteSponsoredLink(): void {
    if (this.id !== null) {
      api
        .deleteSponsoredLink(this.id)
        .then(() => {
          this.$toasted.success("スポンサー広告を削除しました")
          this.emitSponsoredLink()
        })
        .catch((error: AxiosError) => {
          console.log(error.stack)
          this.$toasted.error("スポンサー広告の削除に失敗しました")
        })
    }
  }

  @Emit("emitSponsoredLink")
  private emitSponsoredLink() {
    this.close()
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.priority = 1
    this.title = ""
    this.link = ""
    this.advertiser = ""
    this.thumbnail = { content: "", filename: "" }
    const base64Uploader = this.$refs.base64Uploader as InstanceType<
      typeof Base64Uploader
    >
    base64Uploader.filename = ""
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof Edit>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof Edit>
    return form.resetValidation()
  }

  private loadImage(image: string, filename: string) {
    this.thumbnail.content = image
    this.thumbnail.filename = filename
  }

  public async open() {
    if (this.id !== null) {
      try {
        const response = await api.getSponsoredLink(this.id)
        const sponsoredLink = response.data.sponsoredLink
        this.priority = sponsoredLink.priority
        this.title = sponsoredLink.title
        this.link = sponsoredLink.link
        this.advertiser = sponsoredLink.advertiser
      } catch {
        this.$toasted.error("スポンサー広告の取得に失敗しました")
      }
    }
    this.dialog = true
  }
}
